import React from 'react';
import { showIntercom } from '../../../../customer/utils/ui.utils';
import classes from './render-string-with-contact-us.scss';
const re = /contact us/gi;
function ContactUs({
  contactUsText
}) {
  if (!contactUsText) {
    return null;
  }
  return /*#__PURE__*/React.createElement("span", {
    onClick: () => showIntercom(),
    className: classes.contactUs
  }, contactUsText);
}
export default function RenderStringWithContactUs({
  string
}) {
  const contactUsMatch = string.match(re);
  if (!contactUsMatch) {
    return string;
  }
  const texts = string.split(re);
  return /*#__PURE__*/React.createElement(React.Fragment, null, texts.reduce((acc, text, index) => {
    if (!text) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, acc, /*#__PURE__*/React.createElement(ContactUs, {
        contactUsText: contactUsMatch[index]
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, acc, text, /*#__PURE__*/React.createElement(ContactUs, {
      contactUsText: contactUsMatch[index]
    }));
  }, null));
}